export default __webpack_public_path__ + "static/media/uv11_en_alph_a2.7b581746.mp3";